import urls from "../../../../global/constants/UrlConstants";
import { getNoAuthCallParams, makeCall } from "../../../../utils/service";

export async function verifyOtp(otp: string, userId: string) {
  const body = {
    otp,
    userId,
  };
  try {
    const callParams = getNoAuthCallParams("POST", body);
    const response = await makeCall(urls.VERIFY_OTP, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
